import { useMemo } from 'react';
import { ArticleResponse, ArticleType } from '../../../swagger/putujmoAdminService';
import { propertyOf } from '../../../utils/propertyOf';
import { formatDate } from '../../../utils/dateUtils';
import { ColumnDefinition } from 'react-tabulator';

export const useTableColumnsMemo = (
	articleType: ArticleType,
	phobsNameByPropertyId?: Map<string, string>
) => {

	const columns: ColumnDefinition[] = useMemo(
		() => {
			const titleColumn: ColumnDefinition =
				articleType === ArticleType.PPSCard
					? {
						title: 'Naslov',
						field: propertyOf<ArticleResponse>('title'),
						formatter: (cell: any) => {
							const row: ArticleResponse = cell.getRow().getData();
							if (row.phobsPropertyId) {
								return phobsNameByPropertyId?.get(row.phobsPropertyId) || row.phobsPropertyId;
							}
							return row.title || '';
						}
					}
					: {
						title: 'Naslov',
						field: propertyOf<ArticleResponse>('title')
					};

			let result: ColumnDefinition[] =  [
				{
					title: '',
					rowHandle: true,
					formatter: 'handle',
					headerSort: false,
					frozen: true,
					width: 30,
					minWidth: 30
				},
				titleColumn,

			]

			if (articleType === ArticleType.Blog || articleType === ArticleType.HistoricalHeritage) {
				result = [...result,
					{
						title:'Autor', 
						field: propertyOf<ArticleResponse>('author')
					},
				]
			} else if (articleType === ArticleType.PPSCard) {
				result = [...result,
					{
						title:'Tip', 
						field: propertyOf<ArticleResponse>('ppsCardType')
					},
					{
						title:'Lokacija', 
						field: propertyOf<ArticleResponse>('location')
					},
					{
						title:'Phobs propertyId', 
						field: propertyOf<ArticleResponse>('phobsPropertyId')
					},
					{
						title:'Posebni uslovi', 
						field: propertyOf<ArticleResponse>('specialConditions')
					},
				]
			} else if (articleType === ArticleType.Authenticity) {
				result = [...result,
					{
						title:'Lokacija', 
						field: propertyOf<ArticleResponse>('location')
					},
					{
						title:'Telefon', 
						field: propertyOf<ArticleResponse>('phone')
					},
					{
						title:'Email', 
						field: propertyOf<ArticleResponse>('email')
					},
					{
						title:'Adresa', 
						field: propertyOf<ArticleResponse>('address')
					},
					{
						title:'Web sajt', 
						field: propertyOf<ArticleResponse>('website')
					},
				]
			}

			return [...result, 
			{
				title: 'Poslednja promena',
				field: propertyOf<ArticleResponse>('updatedAt'),
				formatter: (cell: any) => formatDate(cell.getValue())
			}];
		},
		[articleType, phobsNameByPropertyId]
	)

	return columns;
}